export default __webpack_public_path__ + "static/media/Rectangle 2628.e56df3fb.png";